import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { MaterialsGridItemFragmentDoc } from '../materials-grid/materials-grid.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type AddMaterialDialogTagFragment = { __typename: 'Tag', id: string, name: string, organization?: { __typename: 'Organization', id: string } | null };

export type AddMaterialItemWithTextureSetRevisionsFragment = { __typename: 'Material', id: string, legacyId: number, name?: string | null, articleId?: string | null, textureGroup?: { __typename: 'TextureGroup', textureSets: Array<{ __typename: 'TextureSet', textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string }> }> } | null, organization?: { __typename: 'Organization', id: string, name?: string | null } | null, galleryImage?: { __typename: 'DataObject', id: string } | null };

export type AddMaterialDialogMaterialRangeTagsQueryVariables = Types.Exact<{
  organizationId: Types.Scalars['ID']['input'];
}>;


export type AddMaterialDialogMaterialRangeTagsQuery = { __typename: 'Query', tags: Array<{ __typename: 'Tag', id: string, name: string, organization?: { __typename: 'Organization', id: string } | null } | null> };

export type AddMaterialMutationVariables = Types.Exact<{
  input: Types.MutationCreateMaterialInput;
}>;


export type AddMaterialMutation = { __typename: 'Mutation', createMaterial: { __typename: 'Material', id: string, legacyId: number, name?: string | null, articleId?: string | null, organization?: { __typename: 'Organization', id: string, name?: string | null } | null, galleryImage?: { __typename: 'DataObject', id: string } | null } };

export type AddMaterialIncludeTexturesMutationVariables = Types.Exact<{
  input: Types.MutationCreateMaterialInput;
}>;


export type AddMaterialIncludeTexturesMutation = { __typename: 'Mutation', createMaterial: { __typename: 'Material', id: string, legacyId: number, name?: string | null, articleId?: string | null, textureGroup?: { __typename: 'TextureGroup', textureSets: Array<{ __typename: 'TextureSet', textureSetRevisions: Array<{ __typename: 'TextureSetRevision', id: string }> }> } | null, organization?: { __typename: 'Organization', id: string, name?: string | null } | null, galleryImage?: { __typename: 'DataObject', id: string } | null } };

export const AddMaterialDialogTagFragmentDoc = gql`
    fragment AddMaterialDialogTag on Tag {
  id
  name
  organization {
    id
  }
}
    `;
export const AddMaterialItemWithTextureSetRevisionsFragmentDoc = gql`
    fragment AddMaterialItemWithTextureSetRevisions on Material {
  ...MaterialsGridItem
  textureGroup {
    textureSets {
      textureSetRevisions {
        id
      }
    }
  }
}
    `;
export const AddMaterialDialogMaterialRangeTagsDocument = gql`
    query addMaterialDialogMaterialRangeTags($organizationId: ID!) {
  tags(
    filter: {tagType: MaterialRange, organizationId: {equals: $organizationId}}
    take: 9999
  ) {
    ...AddMaterialDialogTag
  }
}
    ${AddMaterialDialogTagFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMaterialDialogMaterialRangeTagsGQL extends Apollo.Query<AddMaterialDialogMaterialRangeTagsQuery, AddMaterialDialogMaterialRangeTagsQueryVariables> {
    override document = AddMaterialDialogMaterialRangeTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddMaterialDocument = gql`
    mutation addMaterial($input: MutationCreateMaterialInput!) {
  createMaterial(input: $input) {
    ...MaterialsGridItem
  }
}
    ${MaterialsGridItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMaterialGQL extends Apollo.Mutation<AddMaterialMutation, AddMaterialMutationVariables> {
    override document = AddMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddMaterialIncludeTexturesDocument = gql`
    mutation addMaterialIncludeTextures($input: MutationCreateMaterialInput!) {
  createMaterial(input: $input) {
    ...AddMaterialItemWithTextureSetRevisions
  }
}
    ${AddMaterialItemWithTextureSetRevisionsFragmentDoc}
${MaterialsGridItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMaterialIncludeTexturesGQL extends Apollo.Mutation<AddMaterialIncludeTexturesMutation, AddMaterialIncludeTexturesMutationVariables> {
    override document = AddMaterialIncludeTexturesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }